import { types } from 'mobx-state-tree';

import { tokenStatusTranslation } from './TokenStore';

export default types
  .model('TokenSummary', {
    title: types.string,
    buyer: types.maybeNull(types.string),
    seller: types.maybeNull(types.string),
    image: types.string,
    alias: types.string,
    location: types.maybe(types.string),
    created_at: types.string,
    price: types.number,
    status: types.maybeNull(types.string),
  })
  .views(self => ({
    get human_status() {
      return tokenStatusTranslation[self.status] || `Unknown status (${self.status})`;
    },
  }));
